import checkImg from "@/assets/checkbox.png"
import uncheckImg from "@/assets/uncheckbox.png"
import styled from "./checkboxinfo.module.css"

export default function checkboxinfo (props: {content: string, checked: boolean, onCheck?: Function}) {
  return <div className={styled.container} onClick={() => props.onCheck && props.onCheck()}>
    <img src={props.checked ? checkImg : uncheckImg} alt="" />
    <span>{props.content}</span>
  </div>
}